import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";

const state = {
    countries: [],
    country: null
};

const getters = {
    getAllCountries: (state) => state.countries,
    getSingleCountry: (state) => state.country,
};

const mutations = {
    setAllCountries(state, countries) {
        state.countries = countries;
    },
    setSingleCountry(state, country) {
        state.country = country;
    }
};

const actions = {
    async fetchAllCountries({ commit }) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query findAllCountry {
                        findAllCountry {
                            id
                            name
                        }
                    }
                `,
                fetchPolicy: 'network-only',
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            commit('setAllCountries', response.data.findAllCountry);
        } catch (error) {
            console.error("Failed to fetch countries:", error);
        }
    },

    async fetchSingleCountry({ commit }, id) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query findOneCountryById($id: Int!) {
                        findOneCountryById(id: $id) {
                            id
                            name
                        }
                    }
                `,
                variables: {
                    id: +id
                },
                fetchPolicy: 'network-only',
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            if (response.data) {
                commit('setSingleCountry', response.data.findOneCountryById);
            }
        } catch (error) {
            console.error("Failed to fetch country:", error);
        }
    },

    async createCountry({ commit, dispatch }, payload) {
        try {
            await apolloClient.mutate({
                mutation: gql`
                    mutation createCountry($countryInput: CountryInput!) {
                        createCountry(countryInput: $countryInput) {
                            id
                            name
                        }
                    }
                `,
                variables: {
                    countryInput: payload
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            dispatch('fetchAllCountries');
        } catch (error) {
            console.error("Failed to create country:", error);
            throw error;
        }
    },

    async updateCountry({ commit, dispatch }, { id, payload }) {
        try {
            await apolloClient.mutate({
                mutation: gql`
                    mutation updateCountry($id: Int!, $countryInput: CountryInput!) {
                        updateCountry(id: $id, countryInput: $countryInput) {
                            id
                            name
                        }
                    }
                `,
                variables: {
                    id: +id,
                    countryInput: payload
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            dispatch('fetchAllCountries');
        } catch (error) {
            console.error("Failed to update country:", error);
            throw error;
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};
